import React, { useEffect, useState } from "react";

import { IoEyeOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import "./index.scss";
function CandidatureResponsiveCards({
  candidature,
  handleStatus,
  setAction,
  loadData,
  setSelectedId,
}) {
  const [plus, setPlus] = useState(false);

  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  function getCVURL(candidatureId) {
    return `${apiUrl}candidatures/${candidatureId}/cv`;
  }

  const navigate = useNavigate();

  return (
    <div id="AbonnementResponsiveCards">
      <div className="card my-4">
        <div className="d-flex ps-3 mt-3 align-items-center ">
          <span className="title me-3">Nom et Prénom:</span>
          <span>{candidature?.fullname}</span>
        </div>
        <hr />
        <div className="d-flex ps-3 align-items-center ">
          <span className="title me-3">Email:</span>
          <span>{candidature?.email}</span>
        </div>{" "}
        <hr />
        <div className="d-flex ps-3 align-items-center ">
          <span className="title me-3"> Télephone:</span>
          <span>{candidature?.phone}</span>
        </div>{" "}
        <hr />
        <div className="d-flex ps-3 align-items-center ">
          <span className="title me-3">cv: </span>
          <span>
            <a href={getCVURL(candidature?._id)} target="_blank">
              {" "}
              {candidature?.cv != null && candidature?.cv}
            </a>
          </span>
        </div>{" "}
        <hr />
        <div className="d-flex ps-3 align-items-center ">
          <span className="title me-3">Mission: </span>
          <span>{candidature?.offerId?.title}</span>
        </div>
        <hr className="mb-0" />
        <div className="d-flex align-items-center ps-3 ">
          <div className="d-flex justify-content-center align-items-center">
            <button
              onClick={() => setPlus(!plus)}
              className="btn btn-link"
              type="button">
              <label className="mx-1">
                <IoEyeOutline style={{ fontSize: "20px" }} />
              </label>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CandidatureResponsiveCards;
